module.exports = __webpack_public_path__ + "img/dayilogo2.25e0af19.png";